import { Button } from './Button'
import { toast } from '../../store/toastStore'

/** Kleiner "Kopieren"-Button für Textfelder (Beschreibung, Technischer Scope, Definition of
 * Done, KI-Arbeitsauftrag, ...) — kopiert den übergebenen Wert in die Zwischenablage und
 * zeigt eine Bestätigung per Toast. */
export function CopyFieldButton({
  value,
  label,
  buttonLabel = 'Kopieren',
}: {
  value: string | null | undefined
  label: string
  buttonLabel?: string
}) {
  const copy = async () => {
    if (!value) return
    await navigator.clipboard.writeText(value)
    toast.success(`${label} kopiert`)
  }

  return (
    <Button size="sm" variant="secondary" disabled={!value} onClick={copy}>
      {buttonLabel}
    </Button>
  )
}
